<template>
  <!-- 选择某个车型弹窗 -->
  <div
    class="hll-popup-bottom-main"
    :class="{ 'hll-popup-bottom-main-on': isShow }"
  >
    <div class="hll-popup-bottom-inner hll-popup-bottom-inner-on">
      <div @click="close" class="hll-close-icon-box">
        <i class="hll-close-icon"></i>
      </div>
      <div class="input-box sub-template-box">
        <h3 class="h-tit">想了解更多？马上找专人咨询</h3>
        <div class="img-group-two-box" v-if="!isNone">
          <img :src="intentionVehicle.img" />
          <div class="right-item">
            <p class="tit-one tit-one-sign">{{ intentionVehicle.name }}</p>
            <p id="change-car-sign" class="tit-three">
              <span class="tit-three-1-sign">{{
                intentionVehicle.downPayment
              }}</span>
              <span class="tit-three-2-sign">{{
                intentionVehicle.introduce
              }}</span>
              <!-- <span class="tit-three-3-sign">元起</span> -->
            </p>
          </div>
        </div>
        <clue-form :optionsData="optionsData" @openCity="openCity" />
        <div class="hll-submit-btn" @click="save">
          <img class="default-img" :src="configData.buttonImg" alt="" />
          <span>立即预约优惠</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { IosInputBug } from "@/utils/util";
import clueForm from "@/components/clueForm";
let iosBug = new IosInputBug();
export default {
  props: ["configData", "optionsData", "intentionVehicle"],
  components: {
    clueForm
  },
  data() {
    return {
      isShow: false,
      isNone: false,
      btnText: ""
    };
  },
  methods: {
    inputFocus() {
      console.log("inputFocus");
      iosBug.open();
    },
    inputBlur() {
      console.log("inputBlur");
      iosBug.close();
    },
    save() {
      // debugger
      // this.$emit('save')
      console.log("save");
      this.$parent.save();
    },
    open(payload) {
      this.btnText = payload.btnText;
      this.isNone = payload.typeName === "none";
      this.isShow = true;
    },
    close() {
      this.isShow = false;
    },
    openCity() {
      this.$emit("openCity");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/css/rpx.scss";
@import "./../common.scss";
.hll-popup-bottom-main {
  background-color: rgba(0, 0, 0, 0);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  transition: all 0.2s ease;
  visibility: hidden;
  display: flex;
  &.hll-popup-bottom-main-on {
    background-color: rgba(0, 0, 0, 0.7);
    visibility: visible;
    .hll-popup-bottom-inner-on {
      visibility: visible;
      transform: translateY(0);
    }
  }
  .ph-box {
    position: relative;
    text-align: center;
    background: #f4f4f4;
    margin-bottom: rpx(24);
    height: rpx(96);
    border-radius: rpx(50);
    width: 100%;
    overflow: hidden;
    .code-right-box {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      color: #ff3821;
      font-size: rpx(26);
      padding-right: rpx(34);
      display: flex;
      align-items: center;
    }
    .hll-cell-value {
      position: relative;
      height: rpx(90);
      text-indent: rpx(30);
      font-size: rpx(28);
      border: none;
      transition: all 0.3s;
      display: flex;
      align-items: center;
      background: #fff;
      .icon-bg {
        position: absolute;
        width: rpx(24);
        height: rpx(24);
        top: 0;
        left: rpx(5);
        bottom: 0;
        margin: auto;
      }
      span {
        vertical-align: middle;
        font-size: rpx(32);
      }
      .no-tit {
        color: #bcc0cd;
      }
    }
    .input-right-close {
      position: absolute;
      width: rpx(60);
      height: rpx(60);
      top: 0;
      right: rpx(10);
      bottom: 0;
      margin: auto;
      z-index: 30;
      .input-close {
        position: absolute;
        width: rpx(24);
        height: rpx(24);
        top: 0;
        right: rpx(10);
        bottom: 0;
        margin: auto;
        width: rpx(24);
        height: rpx(24);
        background: url("~@/assets/img/input-close.png") no-repeat;
        background-size: rpx(24) rpx(24);
        z-index: 30;
      }
    }
    .ph-input {
      padding: rpx(28) 0;
      background: #f4f4f4;
      width: 100%;
      border: none;
      text-indent: rpx(30);
      font-size: rpx(34);
      line-height: rpx(40);
      transition: all 0.3s;
    }
  }
}
.hll-close-icon-box {
  position: absolute;
  right: 0;
  top: 0;
  width: 1.0666666667rem;
  height: 1.0666666667rem;
  z-index: 100;
}
.hll-close-icon-box .hll-close-icon {
  position: absolute;
  top: 0.24rem;
  right: 0.24rem;
  width: 0.2933333333rem;
  height: 0.2933333333rem;
  background: url("~@/assets/img/close.png") no-repeat;
  background-size: 0.2933333333rem 0.2933333333rem;
}
.hll-popup-bottom-inner {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  background-color: #fff;
  transform: translateY(100%);
  transition: all 0.2s ease;
  border-radius: rpx(28) rpx(28) 0 0;
  .hll-right-close-icon {
    position: absolute;
    right: 0.2666666667rem;
    top: 0.2666666667rem;
    width: 0.7733333333rem;
    height: 0.7733333333rem;
    z-index: 10;
    .hll-right-close-icon-inner {
      width: 0.4rem;
      height: 0.4rem;
      float: right;
    }
  }
  .head-tit {
    display: block;
    font-size: 0.4266666667rem;
    color: #333;
    margin: 0.3733333333rem 0;
    text-align: center;
  }
}
.sub-template-box {
  padding: rpx(50) rpx(50);
  .h-tit {
    font-size: rpx(36);
    color: #4a4e5d;
    text-align: center;
    margin: rpx(45) 0 rpx(60) 0;
  }
  .img-group-two-box {
    border: rpx(1) solid #f1f3f6;
    padding: rpx(10);
    background: #f1f3f6;
    margin: 0 auto rpx(20) auto;
    display: flex;
    .right-item {
      flex: 1;
      display: inline-block;
      vertical-align: top;
      margin-left: rpx(20);
      // margin-top: rpx(12);
      border: rpx(1) solid #f1f3f6;
    }
    img {
      height: rpx(180);
    }
    p {
      font-weight: 500;
    }
    .tit-one {
      font-size: rpx(28);
      margin: rpx(20) 0;
      color: #4a4e5d;
    }
    .tit-three {
      color: #ff8b5a;
      span {
        font-size: rpx(24);
      }
      span:nth-child(2) {
        font-size: rpx(30);
        font-weight: bold;
      }
    }
    .tit-two {
      span:first-child {
        font-size: rpx(32);
        color: #ea5e46;
        margin-right: rpx(20);
      }
      span:last-child {
        font-size: rpx(24);
        color: #ea5e46;
      }
    }
  }
  .captcha-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: rpx(30);
    .input-captcha {
      border: none;
      background: #f4f4f4;
      border-radius: rpx(40);
      padding: rpx(20) rpx(30);
      font-size: rpx(36);
      margin-right: rpx(30);
      max-width: rpx(400);
    }
    .btn-get-captcha {
      padding: rpx(10);
      font-size: rpx(32);
      min-width: rpx(200);
      background: #fd960b;
      color: #fff;
      border: none;
      border-radius: rpx(16);
    }
    .btn-get-captcha-disabled {
      background: #d3d1cf;
    }
  }
}
</style>
